const breakSerializer = ((node) => {
  if (node.time) {
    return `<break time="${node.time}"/>`;
  }
  return `<break/>`;
});

export { breakSerializer };
//# sourceMappingURL=serializer.js.map
